module.exports = __webpack_public_path__ + "static/media/KI.3cb19798.svg";